// BE vbdt — VBDT/Controllers/AuthController.cs, UserController.cs
export const apiLogin = '/api/auth/login'
export const apiRefreshToken = '/api/auth/refresh-token'
export const apiForgotPassword = '/api/auth/forgot-password'
export const apiLogout = '/api/auth/logout'
export const apiGetMe = '/api/auth/me'
export const apiVerifyPasswordToken = '/api/auth/verify-password-token'
export const apiSetPassword = '/api/auth/set-password'
export const apiChangePassword = '/api/users/change-password'
export const apiOtpRequest = '/api/auth/otp/request'
export const apiOtpVerify = '/api/auth/otp/verify'
